<template>
  <div v-if="ready" class="page" >
    <div class="box" :style="{ background: `url(${dBg}) top center no-repeat`, backgroundSize: '100% auto' }" >
      <div class="d-logo">
        <tk-image class="img" :src="dLogo" width="110" height="110" ></tk-image>
      </div>
      <div class="d-content">
        <div class="d-title">
          <span>{{lang.download.title}}</span>
        </div>
        <div class="d-text m-t-12">
          <span>{{lang.download.text}}</span>
        </div>
      </div>
      <div class="d-box">
        <div class="title">
          {{lang.download.download}}
        </div>
        <tk-flex class="content" >
          <div class="item" v-for="(item, index) in list" :key="index" >
            <div class="img-box">
              <tk-image :src="item.img" width="120" height="120" ></tk-image>
            </div>
            <div class="name">
              {{item.text}}
            </div>
          </div>
        </tk-flex>

      </div>
      <div class="d-btn" @click="down" >
        {{lang.download.downloadNow}}
      </div>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
import dBg from '../../../assets/image/d-bg.png'
import dLogo from '../../../assets/image/d-logo.png'
import ios from '../../../assets/image/solestage_qrcode_ios.png'
import android from '../../../assets/image/solestage_qrcode_android.png'

import en from './en'
import cn from './cn'
export default {
  components: {
  },
  data () {
    return {
      dBg,
      dLogo,
      ios,
      android,
      cloudUrl: 'https://cloud.solestage.mokekeji.com',
      cloudUrlDev: 'https://cloud.solestage-dev.mokekeji.com',
      url: '',
      lang: {},
      langType: '',
      environment: '',
      ready: false,
      liveList: [],
      list: []
    }
  },
  async mounted () {
    try {
      let params = this.$route.query
      this.url = params.environment === 'dev' ? this.cloudUrlDev : this.cloudUrl
      this.environment = params.environment
      this.appId = params.environment === 'dev' ? this.appIdDev : this.appIdOnline
      this.apolloClient = params.environment === 'dev' ? 'dev' : 'onLine'
      this.lang = params.lang === 'en' ? en : cn
      this.langType = params.lang
      await this.init()
      this.ready = true
    } catch (error) {

    }
  },
  methods: {
    async init () {
      this.list = [
        {
          img: this.ios,
          text: this.lang.download.downloadIos
        },
        {
          img: this.android,
          text: this.lang.download.downloadAndroid
        }
      ]
    },
    down () {
      var ios = 'https://itunes.apple.com/cn/app/Solestage_official/id6443823456?mt=8'
      var android = 'https://www.pgyer.com/T3rp'
      var currentUrl = android
      var u = navigator.userAgent
      var isIOSNum = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOSNum) {
        currentUrl = ios
      }
      // js打开currentUrl链接
      window.open(currentUrl, '_self')
    }

  }
}
</script>

<style lang="scss" scoped>
// css 页面禁止滚动
.page{
  background: #F5F5F5;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  font-family: -apple-system, "Helvetica Neue", Helvetica, "Nimbus Sans L",
      Arial, "Liberation Sans", "PingFang SC", "Hiragino Sans GB",
      "Source Han Sans CN", "Source Han Sans SC", "Microsoft YaHei",
      "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei,
      "WenQuanYi Zen Hei Sharp", sans-serif;
}
.box{
  padding: 30px 20px;
  .d-logo{
    text-align: center;
  }
  .d-content{
    color: #FFFFFF;
    text-align: center;
  }
}
.d-box{
  background: #FFFFFF;
  box-shadow: 0px 14px 44px 8px rgba(181, 181, 181, 0.14);
  border-radius: 15px;
  padding: 20px;
  margin-top: 30px;
  .title{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    font-weight: 700;
    line-height: 20px;
    color: #060A13;
  }
  .content{
    margin-top: 20px;
    .item{
      flex: 1;
      text-align: center;
      .img-box{
        width: 120px;
        height: 120px;
        margin: 0 auto;
        border-radius: 8px;
        overflow: hidden;
        background: #FFFFFF;
      }
      .name{
        font-weight: 300;
        font-size: 13px;
        line-height: 16px;
        color: #84888F;
        margin-top: 10px;
      }
    }
  }
}
.d-btn{
  width: 100%;
  height: 48px;
  line-height: 48px;
  background: #060A13;
  border-radius: 8px;
  color: #FFFFFF;
  margin-top: 40px;
  text-align: center;
}

</style>
